// The right sidebar's two modes — shared between the collapsed icon rail and
// the expanded header strip (RightSidebar.tsx) so editing a label/icon here
// updates both, mirroring nav.ts's NAV/MOBILE_TABS relationship.
import type { ComponentType, SVGProps } from "react";
import { IconAthena, IconGrid } from "@/platform/ui";

type IconType = ComponentType<SVGProps<SVGSVGElement> & { size?: number }>;

interface RightPanelItem {
  key: "overview" | "athena";
  label: string;
  icon: IconType;
}

export const RIGHT_PANELS: RightPanelItem[] = [
  { key: "overview", label: "Overview", icon: IconGrid },
  { key: "athena", label: "Athena", icon: IconAthena },
];

export type RightPanelKey = (typeof RIGHT_PANELS)[number]["key"];

export const DEFAULT_RIGHT_PANEL: RightPanelKey = "overview";

export function isRightPanelKey(value: string | null): value is RightPanelKey {
  return RIGHT_PANELS.some((p) => p.key === value);
}
